import { render, staticRenderFns } from "./DeviceStatus.vue?vue&type=template&id=52ce5c3d&scoped=true&"
import script from "./DeviceStatus.vue?vue&type=script&lang=js&"
export * from "./DeviceStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ce5c3d",
  null
  
)

export default component.exports